import { SVGProps } from "react";

const TickIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="8"
      height="7"
      viewBox="0 0 8 7"
      fill="currentColor"
      {...props}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M3.18712 6.18863C3.05267 6.18863 2.96304 6.14382 2.8734 6.05418L0.677417 3.72375C0.498153 3.54448 0.498153 3.27559 0.677417 3.09632C0.856681 2.91706 1.12558 2.91706 1.30484 3.09632L3.1423 5.06823L6.90685 0.94515C7.0413 0.765886 7.35501 0.72107 7.53428 0.855518C7.71354 0.989966 7.75836 1.30368 7.62391 1.48294L7.57909 1.52776L3.50083 6.00937C3.45601 6.14382 3.32157 6.18863 3.18712 6.18863Z" />
    </svg>
  );
};

export default TickIcon;
